export const GET_CUSTOMERS = "GET_CUSTOMERS"
export const GET_CUSTOMERS_SUCCESS = "GET_CUSTOMERS_SUCCESS"
export const GET_CUSTOMERS_FAIL = "GET_CUSTOMERS_FAIL"

export const SEND_INVITE = "SEND_INVITE"
export const SEND_INVITE_SUCCESS = "SEND_INVITE_SUCCESS"
export const SEND_INVITE_FAIL = "SEND_INVITE_FAIL"

export const CREATE_USER = "CREATE_USER"
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS"
export const CREATE_USER_FAIL = "CREATE_USER_FAIL"

export const CREATE_ADMIN = "CREATE_ADMIN"
export const CREATE_ADMIN_SUCCESS = "CREATE_ADMIN_SUCCESS"
export const CREATE_ADMIN_FAIL = "CREATE_ADMIN_FAIL"

export const SHOW_CREATE_MODAL = "SHOW_CREATE_MODAL"
export const HIDE_CREATE_MODAL = "HIDE_CREATE_MODAL"

export const SHOW_BULK_MODAL = "SHOW_BULK_MODAL"
export const HIDE_BULK_MODAL = "HIDE_BULK_MODAL"

export const SHOW_ADD_TAG_MODAL = "SHOW_ADD_TAG_MODAL"
export const HIDE_ADD_TAG_MODAL = "HIDE_ADD_TAG_MODAL"
export const ADD_TAGS = "ADD_TAGS"
export const ADD_TAGS_SUCCESS = "ADD_TAGS_SUCCESS"
export const ADD_TAGS_FAILED = "ADD_TAGS_FAILED"

export const GET_USER_META_TAGS = "GET_USER_META_TAGS"
export const GET_USER_META_TAGS_SUCCESS = "GET_USER_META_TAGS_SUCCESS"
export const GET_USER_META_TAGS_FAILED = "GET_USER_META_TAGS_FAILED"
export const RESET_USER_META_TAGS = "RESET_USER_META_TAGS"

export const SET_SELECTED_CUSTOMER = "SET_SELECTED_CUSTOMER"
export const UPDATE_CUSTOMER_DATA = "UPDATE_CUSTOMER_DATA"
export const UPDATE_CUSTOMER_DATA_SUCCESS = "UPDATE_CUSTOMER_DATA_SUCCESS"
export const UPDATE_CUSTOMER_DATA_FAILED = "UPDATE_CUSTOMER_DATA_FAILED"

export const CONNECT_USER_TO_PRISM = "CONNECT_USER_TO_PRISM"
export const CONNECT_USER_TO_PRISM_SUCCESS = "CONNECT_USER_TO_PRISM_SUCCESS"
export const CONNECT_USER_TO_PRISM_FAILED = "CONNECT_USER_TO_PRISM_FAILED"

export const SHOW_REMOVE_USER_TAG_MODAL = "SHOW_REMOVE_USER_TAG_MODAL"
export const HIDE_REMOVE_USER_TAG_MODAL = "HIDE_REMOVE_USER_TAG_MODAL"
export const REMOVE_USER_TAG = "REMOVE_USER_TAG"
export const REMOVE_USER_TAG_SUCCESS = "REMOVE_USER_TAG_SUCCESS"
export const REMOVE_USER_TAG_FAILED = "REMOVE_USER_TAG_FAILED"

export const DELETE_PENDING_USERS = "DELETE_PENDING_USERS"
export const DELETE_PENDING_USERS_SUCCESS = "DELETE_PENDING_USERS_SUCCESS"
export const DELETE_PENDING_USERS_FAILED = "DELETE_PENDING_USERS_FAILED"

export const OPEN_DELETE_PENDING_USERS_MODAL = "OPEN_DELETE_PENDING_USERS_MODAL"
export const HIDE_DELETE_PENDING_USERS_MODAL = "HIDE_DELETE_PENDING_USERS_MODAL"

export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_FAILED = "DELETE_USER_FAILED"
export const OPEN_DELETE_USER_MODAL = "OPEN_DELETE_USER_MODAL"
export const HIDE_DELETE_USER_MODAL = "HIDE_DELETE_USER_MODAL"

export const SET_USER_BLOCK_STATUS = "SET_USER_BLOCK_STATUS"
export const SET_USER_BLOCK_STATUS_SUCCESS = "SET_USER_BLOCK_STATUS_SUCCESS"
export const SET_USER_BLOCK_STATUS_FAILED = "SET_USER_BLOCK_STATUS_FAILED"
export const OPEN_USER_BLOCK_STATUS_MODAL = "OPEN_USER_BLOCK_STATUS_MODAL"
export const HIDE_USER_BLOCK_STATUS_MODAL = "HIDE_USER_BLOCK_STATUS_MODAL"
